module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_03-f0b4de0a19ceed39064ee98527071339.png";